// extracted by mini-css-extract-plugin
export default {"container":"Services_container__s5d51","card":"Services_card__hyaYc","front":"Services_front__KFL7-","back":"Services_back__7MKu9"};